import { Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { ProductListFilters } from './product-list-filters.component';
import { ProductListHeadingActions } from './product-list-heading-actions';
import { productListColumns } from './product-list.column';
import { useProductList } from './product-list.hook';

export const ProductList = () => {
    const { data, isLoading, isError, isFetching, error } = useProductList();

    return (
        <SectionContainer isError={isError} error={error} isLoading={isLoading}>
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb items={[{ label: 'Product List' }]} />
                        <SectionTitle>Product List</SectionTitle>
                    </div>

                    <ProductListHeadingActions />
                    {/* <div>
                        <Button type={'button'}>
                            <Link to={Route.PRODUCT_CREATE_NEW}>
                                Create New Product
                            </Link>
                        </Button>
                    </div> */}
                </div>

                <ProductListFilters />
                <SectionDataTable
                    columns={productListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

ProductList.displayName = 'ProductList';
